export default {
  SecurityV1: "/securityv1/",
  SecurityV2: "/securityv2/",
  HotelV3: "/hotelv3/",
  User: "/userv2/",
  HotelV2: "/hotelv2/",
  Communication: "/communicationv1/",
}
